/**
 * Get the good API URL from the configuration.
 */
export const getApiUrl = () => {
    if (process.env.NODE_ENV === "production") {
        if (process.env.REACT_APP_PROD_MODE) {
            // Deployed in production.
            return process.env.REACT_APP_PROD_API_URL
        } else if (process.env.REACT_APP_PREPROD_MODE) {
            // Deployed in PP (preproduction).
            return process.env.REACT_APP_PP_API_URL
        } else {
            // Deployed in QA (recette).
            return process.env.REACT_APP_QA_API_URL
        }
    } else {
        // Development build.
        return process.env.REACT_APP_DEV_API_URL
    }
}

export const getServiceApiUrl = () => {
    if (process.env.NODE_ENV === "production") {
        // Production build.
        if (process.env.REACT_APP_PROD_MODE) {
            // Deployed in production.
            return process.env.REACT_APP_PROD_SERVICE_API_URL
        } else if (process.env.REACT_APP_PREPROD_MODE) {
            // Deployed in PP (preproduction).
            return process.env.REACT_APP_PP_SERVICE_API_URL
        } else {
            // Deployed in QA (recette).
            return process.env.REACT_APP_QA_SERVICE_API_URL
        }
    } else {
        // Development build.
        return process.env.REACT_APP_DEV_SERVICE_API_URL
    }
}
